import React, { useState } from "react"
import { CommandBar, IContextualMenuItem } from "@fluentui/react";
import { UXField } from "./UXField";
import { CForm } from "../../types";
import { IDictionary } from "@ioip/core/lib/utilities";
import { Column, Grid, Row, Title } from "@ioip/core/lib/components";
import { PXActivityInstance } from "../../types/PXActivityInstance";
import CControl from "../types/CControl";

export interface IUIFormProps {
    form: CForm;
    customComponents?: IDictionary<(props: IDictionary<any>) => JSX.Element>;
    activityInstance?: PXActivityInstance;
    isRungime?: boolean;

    /**
     * @default true
     */
    showTitle?: boolean;

    /**
     * Set is commandbar is displayed
     * @default true
     */
    showCommandBar?: boolean;

}

export const UXForm = (props: IUIFormProps): JSX.Element => {

    const title = props.form.title;
    const [ commandBar, setcommandBar ] = useState<IContextualMenuItem[]>();
    const showTitle = props.showTitle == null || props.showTitle == true;
    const showCommandBar = (props.showCommandBar == null || props.showCommandBar == true) && props.form.commandBar?.length > 0;
    const rows = props.form.rows;

    return <>
        {showTitle && <Title text={title} />}
        {showCommandBar && <Row>
            <Column size={12}>
                <CommandBar items={commandBar} className='command-bar-1' />
            </Column>
        </Row>}
        {rows.select(f => <UXField
            field={f.cast<CControl>()}
            key={f.id.toString()}
            customComponents={props.customComponents}
            activityInstance={props.activityInstance}
            isRuntime={props.isRungime}
        />).toArray()}
    </>

}